import { MutableRefObject, ReactNode } from 'react'

export type WidgetInputLargeTextFieldProps = {
	value: string
	onChange: (value: string) => void
	label?: ReactNode
	inputRef?: MutableRefObject<HTMLTextAreaElement | null>
	onCmdEnter?: () => void
	disabled?: boolean
}

export function WidgetInputLargeTextField(
	{ value, onChange, label, inputRef, onCmdEnter, disabled = false }: WidgetInputLargeTextFieldProps,
) {
	return (
		<label className="grid gap-2 text-left ">
			{label && <div className="text-xs text-grey-500">{label}</div>}
			<textarea
				className={`font-normal bg-grey-50/0 py-1.5 px-2 ring-1 ring-black/10 rounded min-h-[100px] w-full ${
					disabled ? 'opacity-60 cursor-not-allowed' : ''
				}`}
				value={value}
				onChange={(e) => onChange(e.target.value)}
				ref={inputRef}
				disabled={disabled}
				onKeyDown={(e) => {
					if (e.key === 'Enter' && e.metaKey) {
						onCmdEnter?.()
					}
				}}
			/>
		</label>
	)
}
